module.exports = __webpack_public_path__ + "img/voice1.ebe1e983.jpg";